export default "assets/images/icons/dotted-line-horizontal-345e11e9.svg";